import React from "react";
import { Container, Row, Col, Table, Accordion, Card } from "react-bootstrap";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const CHECKIN_STEPS = {
  CREATE_ACC: "Account has been created",
  UPLOAD_GOV_ID: "Uploaded Government Issued ID",
  UPLOAD_ID_SELFIE: "Uploaded Selfie",
  SIGN_WAIVER_CONSENT_FORM: "Signed Waiver & Consent Form",
  IN_TAKE_FORM: "Filled In-take Form",
  PAYMENT: "Self Check-In has been completed"
};

const SelfCheckinSteps = ({ bookingDetails }) => {
  const steps = bookingDetails?.selfCheckInCompletedSteps || [];
  const totalSteps = Object.keys(CHECKIN_STEPS).length;
  const completedSteps = Object.keys(CHECKIN_STEPS).filter(stepKey => steps.includes(stepKey)).length;
  const completionPercentage = (completedSteps / totalSteps) * 100;
  const roundedCompletionPercentage = Math.round(completionPercentage / 10) * 10;

  let statusColor;
  if (roundedCompletionPercentage === 100) {
    statusColor = "green";
  } else if (roundedCompletionPercentage >= 50) {
    statusColor = "yellow";
  } else {
    statusColor = "red";
  }

  return (
    <Accordion defaultExpanded className="mb-4 rounded-none">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" style={{ background: "#0000000F" }}>
        <Card.Header className="w-100 border-0 bg-transparent ">
          <Row id="cardTitle" className="w-100">
            <Col md={4} style={{ color: statusColor, fontWeight: roundedCompletionPercentage === 100 ? "bold" : "normal" }}>
              Self Checkin Completion: {roundedCompletionPercentage}% {roundedCompletionPercentage === 100 && "(Completed)"}
            </Col>
          </Row>
        </Card.Header>
      </AccordionSummary>
      <AccordionDetails>
        <Row className="w-100">
          <Col style={{ flex: 1.5 }}>
            <Card className="Card-wrap border-0 shadow-none">
              <Card.Body>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Step</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(CHECKIN_STEPS).map(stepKey => (
                      <tr key={stepKey}>
                        <td>{CHECKIN_STEPS[stepKey]}</td>
                        <td>{steps?.includes(stepKey) ? "✅" : "❌"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <hr />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </AccordionDetails>
    </Accordion>
  );
};

export default SelfCheckinSteps;
